import { Modal } from "antd";
import React from "react";
import Icon from "../../assets/Icon";
import { Loader2 } from "lucide-react";

function StatusCheckModal({
  monitorStatusData,
  monitorStatusModalFlag,
  setMonitorStatusModalFlag,

  setCallFinalLogApi,
  previewFlag,
  network,
  concludeDemo,
  monitorFlag,
  suspiciousFlag,
  currentVideoStream,

  setMonitorStatusData,
  setSuspiciousFlag,
}) {
  const startInterviewHandler = () => {
    setCallFinalLogApi(true);
  };

  const downloadWindowsMonitorFile = (windows = true) => {
    let url;
    if (windows) {
      url =
        "https://hireplusplus-public-in.s3.ap-south-1.amazonaws.com/monitoringTool/windows/HPPMonitoringTool.exe";
    } else {
      url =
        "https://hireplusplus-public-in.s3.ap-south-1.amazonaws.com/monitoringTool/mac/HPPMonitoringTool.dmg";
    }

    const link = document.createElement("a");
    link.href = url;
    // link.download = "windows-monitor-tool.exe"; // file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //   const statusCheck = async () => {
  //     try {
  //       // setLoading(true);

  //       const response = await fetch("http://localhost:9191/api/v1/status", {
  //         method: "GET",
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: "Bearer exdsfrty7365378TerdstAIOP!@123",
  //         },
  //       });

  //       const data = await response.json();

  //       // console.log("Status:", data);
  //       if (data?.resultStatusInfo?.resultCode === "SUCCESS") {
  //         // setMonitorStatusModalFlag(true);
  //         setMonitorStatusData(data?.data);
  //         if (data?.data?.suspicious_count > 0) {
  //           setSuspiciousFlag(true);
  //         } else {
  //           setSuspiciousFlag(false);
  //         }
  //       } else {
  //         // setMonitorStatusModalFlag(false);
  //       }
  //     } catch (error) {
  //       // setMonitorStatusModalFlag(false);
  //       console.error("API Error:", error);
  //     } finally {
  //       // setLoading(false);
  //     }
  //   };

  return (
    <Modal
      //   title={<p className=" text-lg">Interview ID : {interviewId}</p>}
      open={monitorStatusModalFlag}
      centered
      footer={null}
      closable={false}
      style={{ borderRadius: 8 }}
      className="custom-modal rounded"
    >
      {monitorFlag ? (
        <>
          <div className="flex items-center gap-2">
            <span className="p-3 rounded-full bg-red-50">
              <svg
                width="18"
                height="22"
                viewBox="0 0 18 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 6.432L7 9.432L11 11.432L8 14.432M17 10.932C17 15.8404 11.646 19.4104 9.69799 20.5469C9.4766 20.676 9.3659 20.7406 9.20968 20.7741C9.08844 20.8001 8.91156 20.8001 8.79032 20.7741C8.6341 20.7406 8.5234 20.676 8.30201 20.5469C6.35396 19.4104 1 15.8404 1 10.932V6.1496C1 5.35009 1 4.95033 1.13076 4.6067C1.24627 4.30314 1.43398 4.03228 1.67766 3.81753C1.9535 3.57444 2.3278 3.43408 3.0764 3.15335L8.4382 1.14267C8.6461 1.06471 8.75005 1.02573 8.85698 1.01028C8.95184 0.996573 9.04816 0.996573 9.14302 1.01028C9.24995 1.02573 9.3539 1.06471 9.5618 1.14267L14.9236 3.15335C15.6722 3.43408 16.0465 3.57444 16.3223 3.81753C16.566 4.03228 16.7537 4.30314 16.8692 4.6067C17 4.95033 17 5.35009 17 6.1496V10.932Z"
                  stroke="#F97066"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span className="text-xl text-[#101828] font-semibold">
              System monitoring tool
            </span>
          </div>

          <div className="mt-5">
            <p className="text-[#475467] font-semibold">
              Connected Display{" "}
              <span className="text-[#206DC5]">
                ({monitorStatusData?.display_count || "N/A"})
              </span>
            </p>
            <div className="w-full  border-[1px] border-[#D0D5DD] my-2" />
            <div>
              {monitorStatusData?.displays?.map((item, index) => {
                return (
                  <div className="text-[#101828] mb-1">
                    {index + 1}. {item?.name}{" "}
                    <span className="text-gray-500 text-[.85rem]">
                      ({item?.primary && "Primary"})
                    </span>
                  </div>
                );
              })}
              {monitorStatusData?.display_count > 1 && (
                <p className="text-[#D92D20] text-[.85rem]">
                  Note: More than one display is connected. Disconnect extra
                  monitors to proceed.
                </p>
              )}
            </div>
          </div>
          <div className="mt-5">
            <p className="text-[#475467] font-semibold">
              Applications{" "}
              <span className="text-[#206DC5]">
                ({monitorStatusData?.app_count || "N/A"})
              </span>
            </p>
            <div className="w-full  border-[1px] border-[#D0D5DD] my-2" />
            <div className="max-h-[35vh] overflow-y-auto  scroll">
              {monitorStatusData?.apps?.map((item, index) => {
                const isMatched = monitorStatusData?.suspicious_apps?.some(
                  (app) => app.pid === item.pid,
                );
                return (
                  <div
                    key={item.pid}
                    className={` ${isMatched ? "rounded-lg border-2 border-red-500 text-red-500 bg-red-50" : "text-[#101828]"} px-2 py-1 mb-1 font-semibold flex gap-1`}
                  >
                    <div>
                      <p> {index + 1}.</p>
                    </div>
                    <div>
                      <p>{item?.name} </p>
                      <p
                        className={`${isMatched ? "text-red-400" : "text-[#98A2B3]"} font-medium text-[.85rem]`}
                      >
                        {item?.title}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            {monitorStatusData?.suspicious_count > 0 && (
              <div className="text-[#D92D20] text-[.85rem] mt-1">
                Note: Applications marked in red are violating the interview
                guidelines. Please close or remove them to continue.
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="text-[#F97066] font-semibold text-xl flex items-center gap-2">
            <div className="flex gap-3 items-center">
              <Icon type="warning-icon" width="45" height="45" />
              <div className="mt-[.15rem] font-semibold text-[1.1rem] text-[#101828]">
                Monitor Tool Not Detected
              </div>
            </div>
          </div>
          <div className="text-gray-500 mt-5">
            The interview monitoring tool must be running to continue. Please
            start monitor.exe and keep it running throughout your interview.
          </div>
          <div className="mt-4 text-[#2789f9] flex items-center gap-2">
            <span
              onClick={() => downloadWindowsMonitorFile(true)}
              className="hover:brightness-105 underline cursor-pointer"
            >
              Download and run for Windows
            </span>{" "}
            <div className="border-[1px] border-[#53A0F8] h-[18px]" />{" "}
            <span
              onClick={() => downloadWindowsMonitorFile(false)}
              className="hover:brightness-105 underline cursor-pointer"
            >
              Download and run for Mac OS
            </span>{" "}
          </div>
        </>
      )}
      <div className="mt-5 flex sm:flex-row flex-col items-center gap-x-4 gap-y-2">
        <div className="w-full sm:w-[60%]">
          {!monitorFlag ? (
            <div className="text-sm text-[#475467] font-medium flex gap-[.35rem] items-center">
              Fetching monitor tool status..
              <Loader2
                color="#53A0F8"
                strokeWidth={2.8}
                size={21}
                className="animate-spin"
              />
            </div>
          ) : (
            <div className="font-medium text-[#475467] flex gap-[.65rem] items-center">
              Monitor Status:
              <span className="border border-gray-200 shadow-sm px-3 py-1 text-[.82rem] font-semibold rounded-md bg-green-100 text-green-700">
                Detected
              </span>
            </div>
          )}
        </div>
        <button
          className={`${
            previewFlag &&
            network &&
            concludeDemo &&
            monitorFlag &&
            !suspiciousFlag
              ? "btn-blue"
              : "btn-grey-disable"
          } px-[2.6rem] py-[0.4rem] cursor-pointer sm:w-[40%] w-full`}
          disabled={
            !previewFlag ||
            !network ||
            !concludeDemo ||
            !monitorFlag ||
            suspiciousFlag
          }
          onClick={startInterviewHandler}
        >
          Join Interview
        </button>
      </div>
    </Modal>
  );
}

export default StatusCheckModal;
